export default __webpack_public_path__ + "static/B0316-b4bd2e5dadd1cd97bb2b077a8ad7919e.png";